import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntersect = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 16H8V19C8 20.103 8.897 21 10 21H19C20.103 21 21 20.103 21 19V10C21 8.897 20.103 8 19 8H16V5C16 3.897 15.103 3 14 3H5C3.897 3 3 3.897 3 5V14C3 15.103 3.897 16 5 16ZM14.001 14L14 10H14.001V14ZM19 10L19.001 19H10V16H14C15.103 16 16 15.103 16 14V10H19ZM5 5H14V8H10C8.897 8 8 8.897 8 10V14H5V5Z",
		fill: "currentColor"
	})
});
export default SvgIntersect;
